module.exports = __webpack_public_path__ + "img/link-aja v-2.b2a7c7b8.png";